import './styles/main.scss';

import {MuWidget} from "mu-widget/lib/MuWidget";
import {MuBinder} from "mu-widget/lib/MuBinder";
import {MuLabelFor} from "mu-widget/lib/MuLabelFor";
import {MuKeyBind} from "mu-widget/lib/MuKeyBind";
import {registerFrontComponents} from "./gen/frontComponent";
import {registerFilters} from "./filters";
import * as uiFlash from "mu-widget/lib/components/UiFlash";
import {customizeFlash} from "./customize";
import * as checkboxList from "mu-widget/lib/components/InputList";
import * as treeView from "mu-widget/lib/components/TreeView";
import {Triggers} from "mu-js-utils/lib/Triggers";
import {TNames} from "./TNames";

MuBinder.register(MuWidget);
MuKeyBind.register(MuWidget);
MuLabelFor.register(MuWidget, true);

registerFilters(MuBinder);
registerFrontComponents();

// @ts-ignore
MuWidget.registerAs(MuWidget, '.');
MuWidget.registerAll(
    uiFlash,
    checkboxList,
    treeView,
);

MuWidget.startup();

customizeFlash(uiFlash.UiFlashContainer, uiFlash.UiFlashItem);

document.addEventListener("click", () => {
    Triggers.dispatch(TNames.documentClick);
})
/* let swRegistered = false;
Triggers.addHandler(TNames.logged, () => {
    if (!swRegistered) {
        if ('serviceWorker' in navigator)
        {
            navigator.serviceWorker.register('/sw.js');
        }
       swRegistered = true;
    }
}); */

// import * as Sentry from "@sentry/browser";

/* Sentry.init({
    dsn: "https://d467020395ae897387ed3c8e2739d169@o4510548604289024.ingest.de.sentry.io/4510548609466448",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    sendDefaultPii: true
}); */
